import { makeStyles } from "tss-react/mui";

interface IParams {
    isAlert?: boolean;
    hasError?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    container: {
        display: "flex",
        alignItems: "flex-start",
        textAlign: "left",
        border: props.hasError ? `2px solid ${theme.palette.error.main}` : "none",
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2),
        backgroundColor: props.isAlert ? theme.palette.quaternary.main : theme.palette.background.dark,
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    text: {
        marginTop: theme.spacing(0.2),
    },
}));
